<div class="enforcement-mode-notice" data-cy="enforcement-mode-indicator">
  <i class="fa-solid fa-circle-exclamation"></i>
  <div>
    <p>
      <strong>Backups suspended.</strong> The number of resources has exceeded the contracted capacity. Reduce in-scope
      resources or contact your account team to restore backups.
    </p>
  </div>
</div>
